export default __webpack_public_path__ + "static/media/gh1.d6ac0c92.webp";